import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31b03260")

_pushScopeId("data-v-31b03260")
const _hoisted_1 = { class: "p-col-12 p-pb-0" }
const _hoisted_2 = { class: "p-field-radiobutton" }
const _hoisted_3 = { for: "customRange" }
const _hoisted_4 = { class: "p-pl-2 p-pr-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ~ ")
const _hoisted_6 = { class: "p-pl-2" }
const _hoisted_7 = { class: "p-field-radiobutton" }
const _hoisted_8 = { for: "currentSeriesRange" }
const _hoisted_9 = { class: "p-grid" }
const _hoisted_10 = { class: "p-col-6 p-pt-4" }
const _hoisted_11 = { class: "p-field-checkbox" }
const _hoisted_12 = { for: "showUnderQuantile" }
const _hoisted_13 = { class: "p-col-6" }
const _hoisted_14 = { class: "p-inputgroup" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon" }, "%", -1)
const _hoisted_16 = { class: "p-grid" }
const _hoisted_17 = { class: "p-col-6 p-pt-4" }
const _hoisted_18 = { class: "p-field-checkbox" }
const _hoisted_19 = { for: "showUpperQuantile" }
const _hoisted_20 = { class: "p-col-6" }
const _hoisted_21 = { class: "p-inputgroup" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "p-inputgroup-addon" }, "%", -1)
const _hoisted_23 = { class: "p-d-flex p-justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h6", null, _toDisplayString(_ctx.$t("experiment.evaluation.chart-settings.minmax")), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_RadioButton, {
        id: "customRange",
        name: "selectedChartAxisOption",
        value: _ctx.chartAxisOptions[1].key,
        modelValue: _ctx.settings.selectedChartAxisOption,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.settings.selectedChartAxisOption = $event))
      }, null, 8, ["value", "modelValue"]),
      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.chartAxisOptions[1].label), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_InputNumber, {
          id: "customRangeMin",
          modelValue: _ctx.settings.customChartRange.min,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.settings.customChartRange.min = $event)),
          disabled: 
            _ctx.settings.selectedChartAxisOption !== _ctx.chartAxisOptions[1].key
          ,
          class: ["option-input-number", {
            'p-invalid':
              _ctx.settings.selectedChartAxisOption === _ctx.chartAxisOptions[1].key &&
              (_ctx.settings.customChartRange.min === null ||
                _ctx.settings.customChartRange.min === undefined),
          }]
        }, null, 8, ["modelValue", "disabled", "class"])
      ]),
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_InputNumber, {
          id: "customRangeMax",
          modelValue: _ctx.settings.customChartRange.max,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.settings.customChartRange.max = $event)),
          disabled: 
            _ctx.settings.selectedChartAxisOption !== _ctx.chartAxisOptions[1].key
          ,
          class: ["option-input-number", {
            'p-invalid':
              _ctx.settings.selectedChartAxisOption === _ctx.chartAxisOptions[1].key &&
              (_ctx.settings.customChartRange.max === null ||
                _ctx.settings.customChartRange.max === undefined),
          }]
        }, null, 8, ["modelValue", "disabled", "class"])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_RadioButton, {
        id: "currentSeriesRange",
        name: "selectedChartAxisOption",
        value: _ctx.chartAxisOptions[0].key,
        modelValue: _ctx.settings.selectedChartAxisOption,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.settings.selectedChartAxisOption = $event))
      }, null, 8, ["value", "modelValue"]),
      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.chartAxisOptions[0].label), 1)
    ]),
    _createVNode("h6", null, _toDisplayString(_ctx.$t("experiment.evaluation.chart-settings.highlight-quantile")), 1),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_Checkbox, {
            id: "showUnderQuantile",
            modelValue: _ctx.settings.showQuantile.under,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.settings.showQuantile.under = $event)),
            binary: true
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t(
                "experiment.evaluation.chart-settings.highlight-quantile.under"
              )), 1)
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_InputNumber, {
            modelValue: _ctx.settings.highlightQuantile.under,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.settings.highlightQuantile.under = $event)),
            disabled: !_ctx.settings.showQuantile.under,
            class: "p-pl-2 option-input-number",
            allowEmpty: false,
            min: "0",
            max: "100"
          }, null, 8, ["modelValue", "disabled"]),
          _hoisted_15
        ])
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_Checkbox, {
            id: "showUpperQuantile",
            modelValue: _ctx.settings.showQuantile.upper,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.settings.showQuantile.upper = $event)),
            binary: true
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t(
                "experiment.evaluation.chart-settings.highlight-quantile.upper"
              )), 1)
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _createVNode("div", _hoisted_21, [
          _createVNode(_component_InputNumber, {
            modelValue: _ctx.settings.highlightQuantile.upper,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.settings.highlightQuantile.upper = $event)),
            disabled: !_ctx.settings.showQuantile.upper,
            class: "p-pl-2 option-input-number",
            allowEmpty: false,
            min: "0",
            max: "100"
          }, null, 8, ["modelValue", "disabled"]),
          _hoisted_22
        ])
      ])
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode(_component_Button, {
        class: "p-button p-mr-2",
        label: _ctx.$t('autots.label.settings'),
        onClick: _ctx.onSaveSettings
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "p-button p-button-text",
        label: _ctx.$t('button.cancel'),
        onClick: _ctx.onCancelSettings
      }, null, 8, ["label", "onClick"])
    ])
  ]))
})